import { id, zone } from "@planzone/dto";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import {
  handleEditRequest,
  handleEditSuccess,
  handleEditFailure,
} from "./editZone";

const initialState = { ...zone, uuid: id };

const reduceZone = createStateReducer(initialState, {
  [events.editZoneRequested]: handleEditRequest,
  [events.editZoneSucceeded]: handleEditSuccess,
  [events.editZoneFailed]: handleEditFailure,
});

export { reduceZone };
